import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/shared/StatusBadge";
import { cn } from "@/lib/utils";
import { TermsSummary, VersionChip } from "@/components/offers/OfferTerms";
import { OfferFeedbackSummary } from "@/components/offers/DeclineOfferDialog";

// Attribution comes from the server's audit-based `decided_by`; UNKNOWN is shown honestly for decisions recorded before attribution was captured.
export const DECIDED_BY_LABEL = { CLIENT: "Your decision", JIGSAW: "Recorded by Jigsaw on your behalf", UNKNOWN: "Decision recorded (who recorded it was not captured)" };

// Presented-offer card in the approved comparison grammar. Only fields the server projects for clients are shown.
export function ClientOfferCard({ offer: o, isTerminal, onDecide }) {
  const accepted = o.client_decision === "ACCEPTED";
  return (
    <article data-testid={`client-offer-row-${o.id}`} className={cn("flex flex-col rounded-[10px] border bg-white p-4", accepted ? "border-jigsaw-success/50" : "border-jigsaw-border")}>
      <div className="flex items-start justify-between gap-2"><StatusBadge status={o.client_decision} /><VersionChip terms={o.terms} testId={`client-offer-version-${o.id}`} /></div>
      <h3 className="mt-3 text-[16px] font-semibold leading-snug text-jigsaw-navy">{o.supplier_name}</h3>
      <p className="text-[13px] text-jigsaw-muted">{o.property_name || "Property to be confirmed"}</p>
      <div className="mt-4 border-t border-jigsaw-border pt-3">
        <p className="text-[11px] font-semibold uppercase tracking-[0.06em] text-jigsaw-muted">{o.terms?.charging_basis_label || "Rate (charging basis not recorded)"}</p>
        <p className="font-mono-ref text-[28px] font-bold leading-none tracking-[-0.02em] text-jigsaw-navy">
          {o.rate_amount == null ? "—" : Number(o.rate_amount).toFixed(2)}
          <span className="ml-1 text-[13px] font-normal text-jigsaw-muted">{o.currency}</span>
        </p>
      </div>
      <div className="mt-3"><TermsSummary terms={o.terms} testId={`client-offer-terms-${o.id}`} compact /></div>
      <div className="mt-auto pt-4">
        {o.client_decision === "SUPERSEDED" ? (
          <p data-testid={`offer-superseded-${o.id}`} className="text-[12px] text-jigsaw-muted">Replaced by a revised offer from Jigsaw - please decide on the current version.</p>
        ) : o.client_decision === "PENDING" && !isTerminal ? (
          <div className="grid grid-cols-2 gap-2">
            <Button data-testid={`accept-offer-${o.id}`} size="sm" className="bg-jigsaw-success text-white hover:bg-jigsaw-success/90" onClick={() => onDecide(o.id, "ACCEPTED")}>Accept</Button>
            <Button data-testid={`decline-offer-${o.id}`} size="sm" variant="outline" className="text-jigsaw-danger" onClick={() => onDecide(o.id, "DECLINED")}>Decline</Button>
          </div>
        ) : o.client_decision === "PENDING" ? (
          <p data-testid={`offer-closed-${o.id}`} className="text-[12px] text-jigsaw-muted">No longer actionable - request closed</p>
        ) : (
          <p data-testid={`offer-decided-${o.id}`} className="text-[12px] text-jigsaw-muted">{DECIDED_BY_LABEL[o.decided_by] || DECIDED_BY_LABEL.UNKNOWN}</p>
        )}
        <OfferFeedbackSummary offer={o} testId={`client-offer-feedback-${o.id}`} />
      </div>
    </article>
  );
}
